import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthGuard({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[60vh] grid place-items-center text-zinc-500">Loading…</div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}
